/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Paused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Unpaused",
        type: "event",
    },
    {
        inputs: [],
        name: "PACKAGE_VERSION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "hookType",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "metadata",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "message",
                type: "bytes",
            },
        ],
        name: "postDispatch",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "metadata",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "message",
                type: "bytes",
            },
        ],
        name: "quoteDispatch",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "metadata",
                type: "bytes",
            },
        ],
        name: "supportsMetadata",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "unpause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class PausableHook__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
//# sourceMappingURL=PausableHook__factory.js.map